import { Component, OnInit } from '@angular/core';

import { CategoriesAnalytics, PagesAnalytics } from '@app/services/analytics/models/analytics.enum';
import { AnalyticsService } from '@services/analytics/analytics.service';

@Component({
  selector: 'app-total-vacations-detail-modal',
  templateUrl: './total-vacations-detail-modal.component.html',
  styleUrls: ['./total-vacations-detail-modal.component.scss']
})
export class TotalVacationsDetailModalComponent implements OnInit {
  constructor(private analyticsService: AnalyticsService) {}
  ngOnInit(): void {
    this.analyticsService.setPage(
      CategoriesAnalytics.MOT,
      CategoriesAnalytics.VACATIONS_PAGE,
      PagesAnalytics.MORE_INFO
    );
  }
}
